export default "https://c.travel-assets.com/partner-portal/attachment.71fe6ad58bdf.svg";